//type: consts

// Attributes
export const ATTR_IS_COLLAPSED = 'is-collapsed';
export const ATTR_IS_VIRTUAL = 'is-virtual';
export const ATTR_IS_SELECTED = 'is-selected';
export const ATTR_UNREAD = 'unread';
export const ATTR_LEVEL = 'level';
export const ATTR_LABEL = 'label';
export const ATTR_ICON = 'icon';
export const ATTR_ROLE = 'role';
export const ATTR_TITLE = 'title';

// Events
export const EVENT_CLICK = 'click';
export const EVENT_UNREAD_CHANGED = 'bnum-folder:unread-changed';
export const EVENT_SELECT = 'bnum-folder:select';
export const EVENT_TOGGLE = 'bnum-folder:toggle';

// Classes
export const CLASS_CONTAINER = 'bal-container';
export const CLASS_TITLE = 'bal-container__title';
export const CLASS_TITLE_ICON = 'bal-container__title__icon';
export const CLASS_TITLE_NAME = 'bal-container__title__name';
export const CLASS_LEFT = 'bal-container__left';
export const CLASS_LEFT_BADGE = 'bal-container__left__badge';
export const CLASS_TOGGLE = 'bal-container__toggle';
export const CLASS_SUB_FOLDERS = 'bal-sub-folders';
export const CLASS_FLEX = 'flex';
export const CLASS_IS_CUMULATIVE = 'is-cumulative';

// IDs
export const ID_NAME = 'bal-name';

// States
export const STATE_NO_SUBFOLDERS = 'no-subfolders';
export const STATE_TRIPLE_DIGIT = 'triple-digit-unread';
export const STATE_DOUBLE_DIGIT = 'double-digit-unread';
export const STATE_SINGLE_DIGIT = 'single-digit-unread';
export const STATE_NO_UNREAD = 'no-unread';

// Values & Configs
export const VAL_MIN_UNREAD = 0;
export const VAL_MAX_UNREAD = 99;
export const VAL_TRUE = 'true';
export const VAL_FALSE = 'false';
export const VAL_99_PLUS = `${VAL_MAX_UNREAD}+`;
export const VAL_ZERO = '0';
export const VAL_ROLE_TREEITEM = 'treeitem';
export const ARIA_EXPANDED = 'aria-expanded';
export const ARIA_SELECTED = 'aria-selected';
export const CSS_VAR_LEVEL = '--internal-bnum-folder-level';

// Icons
export const ICON_SQUARE = 'square';
export const ICON_ARROW_DOWN = 'keyboard_arrow_down';
export const ICON_ARROW_UP = 'keyboard_arrow_up';
